import callRequestBase from '../../call-request-base/call-request-base';
import callRequestIpForm from './call-request-ip-form/call-request-ip-form.vue';
export default {
	extends: callRequestBase,
	components: {
		callRequestIpForm
	}
};
